import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { assets } from '../lib/assets';

// Homepage section teasing the founders' story
export default function Founders() {
  return (
    <section id="founders" className="relative bg-brand-bg2 py-28 md:py-36 overflow-hidden" data-testid="founders-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          {/* Left: twin portraits */}
          <motion.div
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="lg:col-span-6 relative"
          >
            <div className="grid grid-cols-5 gap-4 relative">
              <div className="col-span-3 aspect-[4/5] rounded-[28px] overflow-hidden relative">
                <img src={assets.pallaviPortrait} alt="Pallavi — co-founder, Pallavit" className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/40 via-transparent to-transparent" />
                <div className="absolute left-5 bottom-5 text-brand-bg">
                  <div className="font-serif text-2xl leading-none">Pallavi</div>
                  <div className="text-brand-gold italic font-serif text-sm mt-1">artist</div>
                </div>
              </div>
              <div className="col-span-2 mt-14 aspect-[4/5] rounded-[28px] overflow-hidden relative">
                <img
                  src={assets.shivangiPortrait}
                  alt="Shivangi — co-founder, Pallavit"
                  className="absolute inset-0 w-full h-full object-cover"
                  style={{ objectPosition: '50% 18%', transform: 'scale(1.35)', transformOrigin: '50% 18%' }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/40 via-transparent to-transparent" />
                <div className="absolute left-4 bottom-4 text-brand-bg">
                  <div className="font-serif text-xl leading-none">Shivangi</div>
                  <div className="text-brand-gold italic font-serif text-xs mt-1">journalist</div>
                </div>
              </div>
            </div>
            <div className="absolute -top-6 -left-6 w-20 h-20 rounded-full bg-brand-gold/10 blur-2xl" />
            <div className="absolute -bottom-6 -right-6 w-24 h-24 rounded-full bg-brand-forest/10 blur-2xl" />
          </motion.div>

          {/* Right: teaser copy */}
          <div className="lg:col-span-6">
            <p className="text-brand-gold tracking-[0.25em] uppercase text-xs mb-5 font-medium">🌿  Rooted by</p>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-[60px] text-brand-ink leading-[1.05] tracking-tight font-light">
              Shivangi & Pallavi.
            </h2>
            <p className="mt-6 text-brand-ink2 text-lg leading-relaxed max-w-xl font-serif italic">
              Some stories are not planned.<br />
              They grow quietly — like seeds waiting for the right season.
            </p>
            <p className="mt-5 text-brand-ink2 text-[16px] leading-relaxed max-w-xl">
              An artist who has always lived close to the soil.
              A journalist who felt a stillness calling her back to it.
              When their paths aligned, a gentle question lingered — <em className="text-brand-forest">what if a gift didn't end… but continued to grow?</em>
            </p>

            <Link
              to="/founders"
              data-testid="founders-read-story-link"
              className="mt-8 inline-flex items-center gap-3 group"
            >
              <span className="rounded-full bg-brand-forest text-brand-bg px-7 py-3.5 text-sm tracking-wide font-medium group-hover:bg-brand-ink transition-all">
                Read their story
              </span>
              <span className="text-brand-forest group-hover:translate-x-1 transition-transform">→</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
